import { render, staticRenderFns } from "./BoxComparison.vue?vue&type=template&id=20951f45&"
import script from "./BoxComparison.vue?vue&type=script&lang=js&"
export * from "./BoxComparison.vue?vue&type=script&lang=js&"
import style0 from "./BoxComparison.vue?vue&type=style&index=0&id=20951f45&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QIcon,QTooltip,QTabs,QTab,QTabPanels,QTabPanel} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QIcon,QTooltip,QTabs,QTab,QTabPanels,QTabPanel})
